export const VEHICLE_ICONS = {
  van: 'van',
  box_van: 'box-van',
  rigid_truck: 'rigid',
  tractor_unit: 'tractor',
  trailer: 'trailer',
  semi_trailer: 'semi-trailer',
  sideload: 'extras-sideload'
};

export const VEHICLE_TYPES = {
  van: 'van',
  box_van: 'box-van',
  rigid_truck: 'rigid',
  tractor_unit: 'tractor_unit',
  trailer: 'trailer',
  semi_trailer: 'semi_trailer'
};

export const TRAILER_SPECS = {
  max_weight: '24000',
  max_pallets: '33',
  container_width: '2.45',
  container_height: '2.70',
  container_length: '13.60',
  length: '14.00',
  mma: '33000'
};

export const MIDDLE_SELECTION_OPTIONS = {
  trailer: 'TRAILER',
  tractor: 'TRACTOR'
};

export const VEHICLES_EXTRAS = {
  has_lateral_loading: 'has_lateral_loading'
};
